import React from 'react'
import { SummaryLine } from '@mobi/betslip/Components/Common/SummaryLine'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import { StatusSilks } from '@core/Areas/AccountActivity/Components/Ticket/Components/StatusSilks'
import { shouldHideLegStatusSilks } from '@core/Areas/AccountActivity/Components/Ticket/Components/StatusSilks/helpers/shouldDisplayLegsStatusSilks'

export const LegsStatusLine: React.FC<{ ticket: Ticket }> = ({ ticket }) => {
  if (shouldHideLegStatusSilks(ticket)) return null

  return <SummaryLine testId='StatusSilks' left='Legs' right={<StatusSilks ticket={ticket} />} />
}
